const loadingLabel = "In caricamento";
const itIT = {
  loadingLabel
};
export {
  itIT as default,
  loadingLabel
};
